module.exports = __webpack_public_path__ + "static/media/3dots.3811e875.svg";